import script from "./ArenaOutline.vue?vue&type=script&setup=true&lang=js"
export * from "./ArenaOutline.vue?vue&type=script&setup=true&lang=js"

import "./ArenaOutline.vue?vue&type=style&index=0&id=4280403b&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4280403b"]])

export default __exports__